<template>
  <screen
    v-show="show"
    :screen-name="$t('tutorial.title')"
    :screen-info="$t('tutorial.contactless')"
    @skip="$emit('skip')"
  >
    <circle-window>
      <full-body />
    </circle-window>
  </screen>
</template>

<script>
import autoNext from '@/mixins/auto-next';

import Screen from '../common/Screen.vue';
import CircleWindow from './CircleWindow.vue';
import FullBody from './FullBody.vue';

export default {
  name: 'TutorialStart',
  components: {
    Screen,
    CircleWindow,
    FullBody,
  },
  mixins: [autoNext],
  data: () => ({
    duration: 9.5,
    audioKey: '7_tutorial_start',
  }),
};
</script>
